export default __webpack_public_path__ + "static/media/fiona.dd83b4be.png";